<!--
 * @Description: 
 * @Date: 2023-05-15 11:54:56
 * @LastEditTime: 2023-05-16 14:25:03
 * @FilePath: \lims-platform\src\views\flowable\components\ActHistoricDetailBtn.vue
-->
<style lang="less">
</style>
<template>
    <span>
        <a :type="btnType" @click="history()">{{ $t(text) }}</a>
        <a-modal :title="$t('审批历史')" v-model="modalLsVisible" :mask-closable="true" :width="1000" :body-style="{height: '600px',overflow: 'hidden',overflowY: 'scroll'}" :footer="null">
            <div v-if="modalLsVisible">
                <TaskTasktempHistoricDetail ref="historicDetail" :data-id="dataId" ></TaskTasktempHistoricDetail>
            </div>
        </a-modal>
    </span>
</template>

<script>
import TaskTasktempHistoricDetail from './TaskTasktempHistoricDetail';
export default {
    name: 'TaskActHistoricDetailBtn',
    components: { TaskTasktempHistoricDetail },
    props: {
        btnType: { type: String, default: 'link', required: false },
        /**/
        dataId: {
            type: String,
            default: '',
            required: true
        }, 
        text: {
            type: String,
            default: '审批历史',
            required: false
        },
    },
    data() {
        return {
            modalLsVisible: false
        };
    },
    created() {
    },
    watch: {
    },
    methods: {
        init(record){
            this.dataId = record.id;
            this.history();
        },
        history() {
            if (!this.dataId) {
                this.$message.error(this.$t('流程实例ID不存在'));
                return;
            }
            this.modalLsVisible = true;
        },
        openModal(record) {
            this.dataId = record.id;
            this.modalLsVisible = true;
        }
    }

};
</script>
